import React, { useState, useEffect } from "react";
import axios from "axios";
import {Stack,  Box, Typography, useTheme, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme.js";

import urls from '../../constants/urls.js';
//import { organizationsData } from "../../data/mockData.js";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header.jsx";
import OrganizationData from "./OrganizationData.jsx";
import OrganizationRegistration from "./OrganizationRegistration.jsx";
import OrganizationUpdate from "./OrganizationUpdate.jsx";

//import { Button } from "antd";
import OrganizationAddSchool from "./OrganizationAddSchool.jsx";

//PCEditModal
import UpdateModal from "./UpdateModal.jsx";


const Organization = () => {
  
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [showOrganizationForm, setShowOrganizationForm]=useState(true);
  const [showOrganizationData, setShowOrganizationData]=useState(false);
  const [showOrganizationUpdate, setShowOrganizationUpdate]=useState(false);
  const [showAddSchool, setShowAddSchool]=useState(false);

  const [buttonOneTitle, setButtonOneTitle]=useState('ORGANIZATIONS DATA')
  
  //organization_id, organization_name, ward_id, district_id,city_id, ward_name, district_name, city_name, 
  //organization_code, street, plot_number, 
  //area_details, telephone_number_1, telephone_number_2, email, website
  
  const[organizationId, setOrganizationId]=useState(0);
  const[organizationName, setOrganizationName]=useState('');
  const[wardId, setWardId]=useState(0);
  const[districtId, setDistrictId]=useState(0);
  const[cityId, setCityId]=useState(0);
  
  const[wardName, setWardName]=useState('');
  const[districtName, setDistrictName]=useState('');
  const[cityName, setCityName]=useState('');

  const[organizationCode, setOrganizationCode]=useState('');
  const[street, setStreet]=useState('');
  const[plotNumber, setPlotNumber]=useState('');
  
  const[areaDetails, setAreaDetails]=useState('');
  const[telephoneNumber1, setTelephoneNumber1]=useState('');
  const[telephoneNumber2, setTelephoneNumber2]=useState('');

  const[email, setEmail]=useState('');
  const[website, setWebsite]=useState('');




  const handleButtonOneClick=()=>{
    if(showOrganizationForm===false){
      setShowOrganizationForm(true);
      setShowOrganizationData(false);
      setShowOrganizationUpdate(false);
      setShowAddSchool(false);
      setButtonOneTitle('ALL ORGANIZATIONS');
    }
    else if(showOrganizationData===false){
      setShowOrganizationData(true);
      setShowOrganizationForm(false);
      setShowOrganizationUpdate(false);
      setShowAddSchool(false);
      setButtonOneTitle('ORGANIZATION FORM');
    }
    else{

    }
  }
   
  const handleShowUpdate=(category, organizationId, organizationName, wardId, districtId, cityId, wardName, districtName, cityName, organizationCode, street, plotNumber, areaDetails, telephoneNumber1, telephoneNumber2, email, website)=>{
     
    if(category==="update"){
      setShowOrganizationUpdate(true);
     setShowOrganizationData(false);
     setShowOrganizationForm(false);
     setShowAddSchool(false);
    }
    else{
      setShowAddSchool(true);
      setShowOrganizationUpdate(false);
     setShowOrganizationData(false);
     setShowOrganizationForm(false);
     
    }
    
    
    
    
    setOrganizationId(organizationId,);
    setOrganizationName(organizationName);
    setWardId(wardId);
    setDistrictId(districtId);
    setCityId(cityId);
  
    setWardName(wardName);
    setDistrictName(districtName)
    setCityName(cityName);

     setOrganizationCode(organizationCode);
     setStreet(street);
     setPlotNumber(plotNumber);
  
     setAreaDetails(areaDetails);
     setTelephoneNumber1(telephoneNumber1);
     setTelephoneNumber2(telephoneNumber2);

      setEmail(email);
      setWebsite(website);



  }


  return (
    <Box m="20px">
      <Header title="ORGANIZATIONS" subtitle="Managing the Organizations" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      > 
        <Stack direction="row" spacing={1}>
        <Box flex={4}> 

        <Button 
          title={buttonOneTitle} 
          onClick={()=>handleButtonOneClick()}
          color="secondary" variant="contained"
          sx={{width: "45%"}}
          >
          {buttonOneTitle} 
          </Button>
        </Box>
          <Box flex={4}>
          
          </Box>
          <Box flex={4}> </Box>
        </Stack>
        <br />
        {
         showOrganizationData? <OrganizationData sendDataToParent={handleShowUpdate} />: ''
        }

        {
         showOrganizationForm? <OrganizationRegistration />: ''
        }
       
       {
       
       showOrganizationUpdate? 
        <OrganizationUpdate 
        organizationId={organizationId} 
        organizationName={organizationName} 
        wardId={wardId}
        districtId={districtId}
        cityId={cityId}
        wardName={wardName} 
        districtName= {districtName}
        cityName={cityName} 
        organizationCode={organizationCode} 
        street={street} 
        plotNumber={plotNumber} 
        areaDetails={areaDetails} 
        telephoneNumber1={telephoneNumber1} 
        telephoneNumber2={telephoneNumber2}
         email={email} 
         website={website}
        />: ''
       }
       


       {
       
       showAddSchool? 
        <OrganizationAddSchool 
        organization_id={organizationId} 
        organization_name={organizationName} 
        ward_id={wardId}
        district_id={districtId}
        city_id={cityId}
        ward_name={wardName} 
        district_name= {districtName}
        city_name={cityName} 
        organization_code={organizationCode} 
        street={street} 
        plot_number={plotNumber} 
        area_details={areaDetails} 
        telephone_number_1={telephoneNumber1} 
        telephone_number_2={telephoneNumber2}
         email={email} 
         website={website}
        />: ''
       }
       
       {/*** organization_id, organization_name, district_id,city_id, district_name,
        *  city_name, organization_code, street, 
        * plot_number, area_details, telephone_number_1, telephone_number_2, email, website**/}
       {/***<UpdateModal />***/}
      </Box>
    </Box>
  );
};

export default Organization;
